import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {  MdCloudUpload, MdDelete, MdBusiness } from 'react-icons/md';
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../firebase.config';
import Loader from './Loader';
import { saveCompany } from '../utils/firebaseFunctions';
import { useStateValue } from '../context/StateProvider';
import { getAllCompany,deletePartner } from '../utils/firebaseFunctions';
import { actionType } from '../context/Reducer';
import Sidebar from './Sidebar';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';

const AddCompany = () => {

  
  const [title, setTitle] = useState('');
  const [field, setField] = useState(false);
  const [alertStatus, setAlertStatus] = useState('danger');
  const [msg, setMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [imageAssest, setImageAssest] = useState(null);
  const [{Brands}, dispatch] = useStateValue();
   const [Company, setCompany] = useState([]);
 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  
   const toggleSidebar = (state) => {
    setIsSidebarOpen(state);
  };
   useEffect(() => {
    fetchCompanyData();  // This ensures the data is fetched when the component mounts
  }, []);

  const uploadImage = (e) => {
    setIsLoading(true);
    const imageFile = e.target.files[0];
    const storageRef = ref(storage, `Images/${Date.now()}-${imageFile.name}`);
    const uploadTask = uploadBytesResumable(storageRef, imageFile);

    uploadTask.on('state_changed',
      (snapshot) => {
        const uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${uploadProgress}% done`);
      },
      (error) => {
        console.error(error);
        setField(true);
        setMsg("Error while uploading: Try again");
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoading(false);
        }, 4000);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);
          setImageAssest(downloadURL);
          setIsLoading(false);
          setField(true);
          setMsg("Image uploaded successfully");
          setAlertStatus("success");
          setTimeout(() => {
            setField(false);
          }, 4000);
        });
      }
    );
  };

  const deleteImage = () => {
    if (!imageAssest) {
      setField(true);
      setMsg("No image to delete");
      setAlertStatus("warning");
      setTimeout(() => {
        setField(false);
      }, 4000);
      return;
    }

    setIsLoading(true);
    const deleteRef = ref(storage, imageAssest);

    deleteObject(deleteRef)
      .then(() => {
        setImageAssest(null);
        setIsLoading(false);
        setField(true);
        setMsg("Image deleted successfully");
                toast.success("Image deleted successfully!");
        
        setAlertStatus("success");
        setTimeout(() => {
          setField(false);
        }, 4000);
      })
      .catch((error) => {
        console.error("Error deleting image:", error);
        setIsLoading(false);
        setField(true);
        setMsg("Error while deleting: Try again");
        setAlertStatus("danger");
        setTimeout(() => {
          setField(false);
        }, 4000);
      });
  };

  const saveDetails = () => {
    setIsLoading(true);
    try {
      if (!title || !imageAssest ) {
        setField(true);
        setMsg("Required fields can't be empty");
        setAlertStatus('danger');
        setTimeout(() => {
          setField(false);
          setIsLoading(false);
        }, 4000);
      } else {
        // Generate a unique ID for both image and data
        const generatedId = `${Date.now()}`;
        
        const data = {
          id: generatedId, // Use the same ID for the folder and data
          title: title,
          imageurl: imageAssest,
        };

        saveCompany(data); // Save data with the generated ID
        console.log('Data to save:', data);
                toast.success("details saved successfully!");
        
        setIsLoading(false);
        setField(true);
        setMsg("Details saved successfully");
        clearData();
        setTimeout(() => {
          setField(false);
        }, 4000);
      }
    } catch (error) {
      console.error(error);
      setField(true);
      setMsg("Error while saving: Try again");
      setAlertStatus('danger');
      setTimeout(() => {
        setField(false);
        setIsLoading(false);
      }, 4000);
    }
    fetchCompanyData();
};


  const clearData = () => {
    setTitle('');
    setImageAssest('');
  };

  const fetchCompanyData = async () => {
    try {
      const data = await getAllCompany();  
      console.log('Fetched Company Data:', data); // Add this line
      setCompany(data);  
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };
  
    const handleDeletePartner = async (id, imageUrl) => {
      // Show confirmation dialog
      const isConfirmed = window.confirm("Are you sure you want to delete this partner?");
      
      if (isConfirmed) {
        try {
          await deletePartner(id, imageUrl);
          toast.success("Partner deleted successfully!");
          fetchCompanyData(); // Refresh partner data after deletion
        } catch (error) {
          console.error("Error deleting partner:", error);
          toast.error("Error deleting partner. Please try again.");
        }
      } else {
        toast.info("Partner deletion cancelled.");
      }
  };
  
  

  return (
    <div className='flex h-2000 overflow-hidden lg:mt-2 mt-0'>
      <Helmet>
        <title>Add Company - Admin Panel</title>
        <meta name="description" content="Add and manage partner companies efficiently." />
      </Helmet>

      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={`flex-1 overflow-y-auto transition-all duration-300 lg:mt-2 mt-10 
          ${isSidebarOpen ? "ml-56 p-2 mr-[-16px] " : "lg:ml-20 sm:ml-2 lg:p-8 sm:p-6"}`}  
        >
        <div className='w-full max-w-3xl mx-auto p-4'>
        <h1 className="lg:text-2xl text-md font-bold mb-4">Add Partner</h1>
          <div className='space-y-4 border-gray-300 rounded-lg'>
            
          {field && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={`w-full p-2 rounded-lg text-center lg:text-[15px] text-[13px] font-semibold ${alertStatus === "danger" ? "bg-red-400 text-red-800" : alertStatus === "success" ? "bg-green-400 text-green-800" : "bg-yellow-400 text-yellow-800"
                  }`}
              >
                {msg}
              </motion.p>
            )}
            
            <div className='flex items-center border-b border-gray-300 py-2'>
              <MdBusiness className='lg:text-xl text-lg text-gray-700' />
              <input
                type="text"
                className='w-full h-full lg:text-[15px] text-[13px] bg-transparent outline-none border-none placeholder:text-gray-400 text-gray-900 pl-3'
                required
                value={title}
                placeholder='Enter Partner Name'
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
  
            <div className='relative flex justify-center items-center border-2 border-dotted border-gray-300 w-full h-56 rounded-lg overflow-hidden cursor-pointer'>
              {isLoading ? <Loader /> : (
                <>
                  {!imageAssest ? (
                    <label className='flex flex-col items-center justify-center w-full h-full cursor-pointer'>
                      <MdCloudUpload className='text-gray-500 lg:text-3xl text-xl hover:text-gray-700' />
                      <p className='text-gray-500 hover:text-gray-700 lg:text-[15px] text-[13px]'>Click here to upload Partner Logo</p>
                      <input type="file" accept='image/*' onChange={uploadImage} className='w-0 h-0' />
                    </label>
                  ) : (
                    <div className='relative w-100 h-40'>
                      <img
                        src={imageAssest}
                        alt="uploaded"
                        className='w-full h-full object-cover rounded-lg'
                      />
                      <button
                        className='absolute top-3 right-3 p-2 rounded-full bg-red-500 text-white text-xl hover:bg-red-600'
                        onClick={deleteImage}
                      >
                        <MdDelete />
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
  
            <div className='flex items-center'>
              <button
                type='button'
  className="relative inline-block border border-[#005eb8] text-[#005eb8] lg:text-[15px] text-[13px] font-[500] leading-[1.5] px-[30px] py-[10px]  transition-all duration-200 hover:bg-[#005eb8] hover:text-white"
                onClick={saveDetails}
              >
                Save
              </button>
            </div>
          </div>
              {/* Table Section */}
                  {/* Table Section */}
<div className='mt-8 overflow-x-auto'>
  <h2 className='lg:text-lg text-md font-semibold'>Partner Details</h2>
  {Company.length === 0 ? (
    <p>No Partner data available.</p>
  ) : (
    <table className='min-w-full border-collapse border border-gray-300'>
      <thead>
        <tr className='bg-gray-200'>
          <th className='border border-gray-300 px-4 py-2'>ID</th>
          <th className='border border-gray-300 px-4 py-2'>Image</th>
          <th className='border border-gray-300 px-4 py-2'>Title</th>
          <th className='border border-gray-300 px-4 py-2'>Actions</th>
        </tr>
      </thead>
      <tbody>
        {Company.map((company) => (
          <tr key={company.id}>
            <td className='border border-gray-300 px-4 py-2'>{company.id}</td>
            <td className='border border-gray-300 px-4 py-2'>
              <img src={company.imageurl} alt={company.title} className='max-w-40 max-h-40 object-contain' />
            </td>
            <td className='border border-gray-300 px-4 py-2 lg:text-[15px] text-[13px]'>{company.title}</td>
            <td className='border border-gray-300 px-4 py-2 text-center'>
              <button onClick={() => handleDeletePartner(company.id, company.imageurl)}>
                <MdDelete className='text-red-600 text-xl' />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )}
</div>

        </div>
      </div>
    </div>
  );
  
};

export default AddCompany;
